export default {
  default: () => import("/home/cyburstud/developer/github/cubpp/mileage.autos/layouts/default.vue").then(m => m.default || m)
}